(function () {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getHeaderOffset() {
    const header = document.querySelector('.td-header-wrapper');
    if (!header) return 0;
    const bottom = Math.round(header.getBoundingClientRect().bottom);
    return bottom > 0 ? bottom : 0;
  }

  function scrollToTarget(target) {
    const offset = getHeaderOffset() + 16;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: REDUCED_MOTION ? 'auto' : 'smooth',
    });
  }

  function onClick(event) {
    const link = event.target.closest('[data-td-starter-kit-scroll]');
    if (!link) return;

    const targetId = link.getAttribute('data-td-starter-kit-scroll');
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();
    scrollToTarget(target);
  }

  document.addEventListener('click', onClick);
})();
